import React from 'react'
import { ArrowUpRight } from 'lucide-react'

export function Hero({ visible = true, phoneNumber = '18763932065' }) {
  const whatsappUrl = `https://wa.me/${phoneNumber}`

  return (
    <div
      className={`bg-white ${visible ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 pt-20 md:pt-6`}
    >
      <style>{`
        .hero-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .hero-cta {
          display: inline-flex;
          align-items: center;
          background: #111;
          color: #fff;
          border-radius: 8px;
          overflow: hidden;
          text-decoration: none;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid #111;
          transition: opacity 0.2s;
        }

        .hero-cta:hover {
          opacity: 0.75;
        }

        .hero-cta-label {
          padding: 14px 24px;
        }

        .hero-cta-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-left: 1px solid rgba(255,255,255,0.15);
          flex-shrink: 0;
        }

        .hero-stat-box {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 18px 22px;
          border: 1px solid #e8e8e8;
          border-radius: 10px;
          max-width: 380px;
        }

        .hero-image-wrap {
          position: relative;
          width: 100%;
          overflow: hidden;
          border-radius: 12px;
          background: #f0ede8;
        }

        .hero-image-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* Mobile: zoom/crop the portrait so it looks sharper */
        .hero-img {
          object-position: center 20%;
          transform: translateZ(0);
          will-change: transform;
        }

        @media (max-width: 640px) {
          .hero-img {
            transform: scale(1.12) translateZ(0);
          }
        }

        .hero-divider {
          width: 100%;
          height: 1px;
          background: #efefef;
          margin: 8px 0;
        }

        .hero-delivered-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #22c55e;
          flex-shrink: 0;
          box-shadow: 0 0 0 3px rgba(34,197,94,0.15);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16 py-12 sm:py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left — content */}
          <div className="order-2 lg:order-1 text-center lg:text-left">

            {/* Live badge */}
            <div className="flex items-left gap-2 justify-center mb-6 lg:justify-start">
              <span
                className="hero-tag border-transparent p-0 text-xs font-bold tracking-wide"
                style={{
                 
                  color: "#b91c1c",
                  borderColor: "#fca5a5",
                  fontWeight: 700,
                  borderRadius: "999px",
                  padding: "4px 12px",
                  display: "inline-block"
                }}
              >
                60+ Projects Delivered  
              </span>
            </div>

            {/* Heading */}
            <h1
              style={{
                fontWeight: 700,
                fontSize: "clamp(30px, 4.5vw, 54px)",
                lineHeight: 1.1,
                color: "#111",
                marginBottom: "28px",
                maxWidth: "540px",
              }}
              className="mx-auto lg:mx-0"
            >
              Building Exceptional{" "}
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>Digital Experiences</span>{" "}
               That Elevate Your Brand
            </h1>

            {/* Body */}
            <p style={{ color: "#666", fontSize: "15px", lineHeight: 1.8, maxWidth: "440px", marginBottom: "32px" }}
              className="mx-auto lg:mx-0">
              Bringing creativity and technical excellence together. We deliver logos, websites, and mobile solutions that position your business for long-term success.
            </p>

            {/* CTA */}
            <div style={{ marginBottom: "36px" }} className="flex  justify-center lg:justify-start">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hero-cta">
                <span className="hero-cta-label text-white font-bold">Contact Us on WhatsApp</span>
                <span className="hero-cta-icon">
                  <ArrowUpRight size={18} strokeWidth={2.5} className="text-white" />
                </span>
              </a>
            </div>

            <div className="hero-divider" style={{ maxWidth: "380px" }} />

            {/* Stat */}
            <div className="hero-stat-box  mx-auto lg:mx-0" style={{ marginTop: "24px" }}>
              <span style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontWeight: 700,
                fontSize: "clamp(28px, 3vw, 40px)",
                color: "#111",
                lineHeight: 1,
                letterSpacing: "-0.02em",
              }}>
                3+
              </span>
              <span style={{ fontSize: "13px", color: "#888", fontWeight: 500, lineHeight: 1.4 }}>
                Years of Industry<br />Experience
              </span>
            </div>

          </div>

          {/* Right — image */}
          <div className="order-1 lg:order-2 w-full">
            <div className="hero-image-wrap aspect-square lg:aspect-[4/5]">
              <img className="hero-img" src="/Keston%20PSD%201.jpg" alt="KDPS founder portrait" />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}